import React, {Component} from 'react';
import renderIf from 'render-if';
import './anomaly.css';
import {removeTokenUserStorage, setAlertOnRedux, validRemoveTokenUserStorage} from "../../actions";
import {alertLabels, labels, messages} from "../../util/constants";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faSave,faTimes} from "@fortawesome/free-solid-svg-icons";
import {Button, FormControl,Grid, InputLabel, Paper,TextField} from "@material-ui/core/umd/material-ui.production.min";
import MultiSelectField from "../../components/multiSelect/multiSelect";
import {TableGridAnomaly} from "../../components/TableGridAnomaly/tableGridAnomaly";
import httpHttpsRequest from '../../util/http-request/request';
import { getDataTesisAnomalyOptions, getAnomalyOptions, postAnomalyOptions, deleteAnomalyOptions } from '../../util/optionsRequest';

class Anomaly extends Component {

    constructor(props){
        super(props);

        this.state ={
            id_claimed: props.idClaimed,
            anomalyTesisData: [],
            anomalyData: [],
            anomalySelected : [],
            anomalyAliasPT : '',
            anomalyAliasUS : '',
            anomalyAliasES : '',
        }
    };

    componentWillMount(){
       this.getDataTesisAnomaly();
       this.getDataAnomaly();
    };

    getDataTesisAnomaly=()=>{
        let param = {'id_claimed':this.state.id_claimed};

        let http = new httpHttpsRequest(getDataTesisAnomalyOptions);
        http.addQueryString(param);

        http.makeRequest().then((data)=>{this.anomalyTesisSuccess(JSON.parse(data))})
            .catch((data)=>{this.callBackError(data)})
    };

    getDataAnomaly=()=>{
        let param = {'id_claimed':this.state.id_claimed};

        let http = new httpHttpsRequest(getAnomalyOptions);
        http.addQueryString(param);

        http.makeRequest().then((data)=>{this.anomalySuccess(JSON.parse(data))})
            .catch((data)=>{this.callBackError(data)})
    };

    saveAnomaly = () =>{
        let params = {
            id_anomaly : this.state.anomalySelected.value,
            id_claimed: this.state.id_claimed,
            anomaly_tesis_label : this.state.anomalySelected.label,
            anomaly_name_pt : this.state.anomalyAliasPT,
            anomaly_name_us : this.state.anomalyAliasUS,
            anomaly_name_es : this.state.anomalyAliasES
        };

        let http = new httpHttpsRequest(postAnomalyOptions);
        http.addRequestBody(params);
        http.makeRequest().then((data)=>{this.saveAnomalySuccess(JSON.parse(data))})
            .catch((data)=>{this.callBackError(data)})
    };

    anomalyTesisSuccess = (response) =>{
        if(response.data && response.data.length > 0){
            this.setState({anomalyTesisData:response.data});
        }else{
            setAlertOnRedux(true,alertLabels.iconError,messages.getAnomalyTesisError, alertLabels.alertDanger);
        }
    };

    anomalySuccess = (response) =>{
        try{
            if(response.data){
                this.setState({anomalyData:response.data});
            }
        }catch(err){
            setAlertOnRedux(true,alertLabels.iconError,response.requestErrorDefault, alertLabels.alertDanger);
        }
    };

    saveAnomalySuccess = (response) =>{
        try{
            if(response != null && response.success == true){
                setAlertOnRedux(true,alertLabels.iconSuccess,messages.anomalySaved, alertLabels.alertSuccess);
            }else{
                setAlertOnRedux(true,alertLabels.iconError,response.message, alertLabels.alertDanger);
            }
            this.getDataAnomaly();
            this.clearFields();
        }catch(err){
            setAlertOnRedux(true,alertLabels.iconError,response.requestErrorDefault, alertLabels.alertDanger);
        }
    };

    callBackError = (response) => {
        try {
            if (validRemoveTokenUserStorage(response.statusCode)) {
                removeTokenUserStorage();
            }
            setAlertOnRedux(true, alertLabels.iconError, messages.requestErrorDefault, alertLabels.alertDanger);
        }catch(err){
            setAlertOnRedux(true, alertLabels.iconError, messages.requestErrorDefault,alertLabels.alertDanger);
        }
    };

    changeAnomaly = (anomalySelected) => {
        if(anomalySelected){
            this.setState({anomalySelected});
        }
        else{
            this.setState({anomalySelected:[]});
        }
    };

    cancelAction = () =>{
        this.clearFields();
    };

    clearFields = ()=>{
        this.setState({
            anomalySelected : [],
            anomalyAliasPT : '',
            anomalyAliasUS : '',
            anomalyAliasES : '',
        });
    };

    editAnomaly = (anomaly) =>{
        this.setState({
            anomalySelected : {value:anomaly.id_anomaly , label: anomaly.anomaly_tesis_label},
            anomalyAliasPT : anomaly.anomaly_name_pt,
            anomalyAliasUS : anomaly.anomaly_name_us,
            anomalyAliasES : anomaly.anomaly_name_es,
        });
    };

    removeAnomaly = (anomaly) =>{
        let confirmDelete = window.confirm(messages.confirmDeleteAnomaly + '\n'+ anomaly.anomaly_name_pt );//todo - validar idioma

        if (confirmDelete) {
            let params = {
                id_anomaly_private: anomaly.id_anomaly_private
            };
            let http = new httpHttpsRequest(deleteAnomalyOptions);
            http.addQueryString(params);

            http.makeRequest().then((data)=>{this.removeAnomalySuccess(JSON.parse(data))})
                .catch((data)=>{this.callBackError(data)})
        }
    };

    removeAnomalySuccess = (response) =>{
        try{
            if(response != null && response.success == true){
                setAlertOnRedux(true,alertLabels.iconSuccess,messages.anomalyRemoved, alertLabels.alertSuccess);
            }else{
                setAlertOnRedux(true,alertLabels.iconError,response.message, alertLabels.alertDanger);
            }
            this.getDataAnomaly();
        }catch(err){
            setAlertOnRedux(true,alertLabels.iconError,response.requestErrorDefault, alertLabels.alertDanger);
        }
    };

    validShowButtonSave = ()=>{
        if(this.state.anomalySelected && this.state.anomalySelected.value
            && this.state.anomalyAliasPT.length > 0){
            return (
                <Button variant="contained"  color="primary" onClick={this.saveAnomaly}>
                    <FontAwesomeIcon icon={faSave}/> &nbsp;&nbsp;{labels.save}
                </Button>
            );
        }
    };

    validShowButtonCancel = (condition)=>{
        if(condition){
            return (
                <Button variant="contained" style={{marginRight: '2%'}} color="secondary" onClick={this.cancelAction}>
                    <FontAwesomeIcon icon={faTimes}/> &nbsp;&nbsp;{labels.cancel}
                </Button>
            );
        }
    };

    validShowLabelAnomaly = () =>{
        if (this.state.anomalySelected && this.state.anomalySelected.value) {
            return <InputLabel htmlFor="multiSelectAnomaly">{labels.anomalySelectedLabel}</InputLabel>;
        } else {
            return <InputLabel htmlFor="multiSelectAnomaly">{labels.selectAnomaly}</InputLabel>
        }
    };

    validShowLabelNewAnomaly = () =>{
        if (this.state.anomalyData.length > 0) {
            return (
                <div className={'div-items'}>
                    <h4> {'\u00A0'} {labels.addNewAnomaly}</h4>
                </div>
            );
        } else {
            return (
                <div className={'div-items'}>
                    <h4> {'\u00A0'} {labels.addFirstAnomalyToClaimed}</h4>
                </div>
            );
        }
    };

    render() {

        return (
            <div className="container">
                {this.validShowLabelNewAnomaly()}
                <Grid item xs={12} container spacing={8}>
                    <Grid item xs={6}>
                        <Paper className={styles.paper}>
                            <div className={'div-paper'}>
                                {this.validShowLabelAnomaly()}
                                <MultiSelectField id="multiSelectAnomaly" data={this.state.anomalyTesisData} multi={false} handleSelectChange={this.changeAnomaly}
                                                  valuesSelected={this.state.anomalySelected} placeHolder={labels.selectAnomalyPlaceHolder} />
                            </div>
                        </Paper>
                    </Grid>
                    <Grid item xs={6}>
                        <Paper className={styles.paper}>
                            {
                                renderIf(this.state.anomalySelected && this.state.anomalySelected.value)
                                (
                                    <div>
                                        <div className={'div-paper'}>
                                            <FormControl className="formControlAnomaly">
                                                <TextField
                                                    label={labels.anomalyAliasPT}
                                                    value={this.state.anomalyAliasPT}
                                                    onChange={(input)=>{this.setState({anomalyAliasPT:input.target.value})}}
                                                />
                                            </FormControl>
                                        </div>
                                        <div className={'div-paper'}>
                                            <FormControl className="formControlAnomaly">
                                                <TextField
                                                    label={labels.anomalyAliasUS}
                                                    value={this.state.anomalyAliasUS}
                                                    onChange={(input)=>{this.setState({anomalyAliasUS:input.target.value})}}
                                                />
                                            </FormControl>
                                        </div>
                                        <div className={'div-paper'}>
                                            <FormControl className="formControlAnomaly">
                                                <TextField
                                                    label={labels.anomalyAliasES}
                                                    value={this.state.anomalyAliasES}
                                                    onChange={(input)=>{this.setState({anomalyAliasES:input.target.value})}}
                                                />
                                            </FormControl>
                                        </div>

                                        <div className={'div-btn'}>
                                            {this.validShowButtonCancel((this.state.anomalySelected && this.state.anomalySelected.value))}
                                            {this.validShowButtonSave()}
                                        </div>

                                    </div>
                                )
                            }
                        </Paper>
                    </Grid>
                </Grid>
                {
                    renderIf(this.state.anomalyData.length == 0)
                    (
                        <div className={'div-padding'}/>
                    )
                }
                {
                    renderIf(this.state.anomalyData.length > 0)
                    (
                        <div className={'div-table'}>
                            <h4> {'\u00A0'} {labels.yourAnamolies}</h4>
                            <TableGridAnomaly options={[]} data={this.state.anomalyData}
                                              editAnomaly={this.editAnomaly} removeAnomaly={this.removeAnomaly} />
                        </div>
                    )
                }

            </div>
        )
    }
}
const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing.unit,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        margin: '2%',
    },
});

export default Anomaly;


// WEBPACK FOOTER //
// ./src/containers/cst_group/anomaly.js